import React from 'react';

import { Button } from 'react-bootstrap5';

import imgWelcome from 'images/new_ui/onboarding/cpa_only_welcome.png';

import { useContext } from '../Context';
import ProductivityDiagramIcon from './ProductivityDiagramIcon';
import WellbeingDiagramIcon from './WellbeingDiagramIcon';

export default function WelcomeCpa() {
  const { dispatch, state, actions } = useContext();

  const onGoNextClick = () => {
    actions.completeStep(state.steps[state.currentStep].step, () => {
      actions.setNextStep({
        dispatch,
        steps: state.steps,
        isPossibleSkip: true,
        currentStep: state.currentStep,
      });
    });
  };

  return (
    <div className="content onboarding-content">
      <div className="row">
        <div className="col-lg order-lg-last">
          <img src={imgWelcome} style={{ maxWidth: '100%', objectFit: 'cover' }} alt="Welcome" />
        </div>
        <div className="col-lg order-lg-first">
          <div className="pt-4 p-sm-4 pe-lg-0">
            <h1>Welcome to LeggUP!</h1>

            <h2 className="mt-4">Health and Performance Assessment</h2>
            <p>
              Our science-backed assessment gives you feedback about your health
              and performance factors that identify work readiness and
              needed support areas.
            </p>

            <div className="d-flex mt-3">
              <div className="text-center w-50">
                <ProductivityDiagramIcon />

                <div className="mt-2 fs-5">
                  PRODUCTIVITY
                  <br />
                  MEASURES
                </div>
              </div>

              <div className="text-center w-50">
                <WellbeingDiagramIcon />

                <div className="mt-2 fs-5">
                  WELLBEING
                  <br />
                  INDEX
                </div>
              </div>
            </div>

            <p className="text-center fw-semibold mt-5">
              See how you&apos;re doing today..
            </p>

            <Button
              onClick={onGoNextClick}
              className="d-block d-sm-inline-block mt-4 mt-sm-3"
            >
              See How
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
